var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#34366d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.999 1.307)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(0.001 -0.307)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.5 5.551) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8.045,
    y2: 8.045,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 8.045,
    y2: 8.045,
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.48ed57aa4d2289cd14a1a9ea559816ce.svg";
export { ForwardRef as ReactComponent };